var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0c1.105 0 2 1.023 2 2.286v11.428C16 14.977 15.105 16 14 16H2c-1.105 0-2-1.023-2-2.286V2.286C0 1.023.895 0 2 0h12zm.24 1.5H1.76c-.144 0-.26.139-.26.31v12.38c0 .171.116.31.26.31h12.48c.144 0 .26-.139.26-.31V1.81c0-.171-.116-.31-.26-.31zM8 3c.687 0 1.334.128 1.942.384a4.952 4.952 0 0 1 1.595 1.068c.455.456.813.986 1.073 1.589S13 7.29 13 7.977c0 .687-.13 1.336-.39 1.947a5.082 5.082 0 0 1-1.073 1.607c-.456.46-.986.82-1.59 1.08A4.87 4.87 0 0 1 8 13c-.687 0-1.334-.13-1.942-.39a4.983 4.983 0 0 1-1.595-1.08A5.082 5.082 0 0 1 3.39 9.925 4.925 4.925 0 0 1 3 7.977c0-.687.13-1.333.39-1.936a5.049 5.049 0 0 1 1.073-1.59c.456-.455.99-.811 1.601-1.067A4.96 4.96 0 0 1 8 3zM5.161 6.352c-.164.257-.29.533-.38.828a3.18 3.18 0 0 0-.133.925c0 .897.315 1.663.947 2.297a3.11 3.11 0 0 0 2.286.95c.328 0 .642-.044.942-.133.3-.09.575-.223.825-.4L5.16 6.351zm2.844-1.605c-.322 0-.63.042-.924.124-.294.083-.57.203-.828.361l4.494 4.515a3.57 3.57 0 0 0 .371-.835 3.22 3.22 0 0 0 .135-.932c0-.89-.318-1.652-.952-2.284a3.134 3.134 0 0 0-2.296-.949z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.da980963ebe7e7c10de38e572d6120bf.svg";
export { ForwardRef as ReactComponent };